import { Box, Button, Link, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Link as RouterLink, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Scrollbar } from '../../../../components/atoms/scrollbar';
import AvatarWithInfo from '../../../../components/molecules/avatar-with-info';
import { BillingGroupMeili } from '../../api/types/billing-group';

import { DataStatusIndicator } from '@/components/molecules/data-status-indicator/data-status-indicator';

interface Props {
  data: BillingGroupMeili[];
  isLoading: boolean;
  error: string;
}

export const BillingGroupsTable = ({ data, isLoading, error }: Props) => {
  const { t } = useTranslation(['billingGroups', 'common']);

  const navigate = useNavigate({ from: '/billing-groups/' });

  const columns = [
    {
      id: 'name',
      label: t('billingGroups:table.name'),
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}>
      <Scrollbar>
        <Table sx={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map(group => (
              <TableRow hover key={group.id}>
                <TableCell>
                  <Link
                    color="primary"
                    underline="none"
                    component={RouterLink}
                    to={`${group.id}`}
                    variant="inherit">
                    <AvatarWithInfo
                      avatarText={`${group.name.slice(0, 1)}`}
                      primaryText={`${group.name} `}
                      secondaryText=""
                      src=""
                    />
                  </Link>
                </TableCell>
                <TableCell align="right">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      navigate({ to: `${group.id}` });
                    }}>
                    {t('common:seeDetails')}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Scrollbar>
      <DataStatusIndicator dataLength={data?.length} isFetching={isLoading} error={error} />
    </Box>
  );
};
